import { render, staticRenderFns } from "./repeDetail.vue?vue&type=template&id=576be58d&scoped=true&"
import script from "./repeDetail.vue?vue&type=script&lang=js&"
export * from "./repeDetail.vue?vue&type=script&lang=js&"
import style0 from "./repeDetail.vue?vue&type=style&index=0&id=576be58d&scoped=true&lang=css&"
import style1 from "./repeDetail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576be58d",
  null
  
)

export default component.exports